// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__1fLjf","loadingShrink":"PageLoading_loadingShrink__2nAa3"};